import { render, staticRenderFns } from "./HeaderRubric.vue?vue&type=template&id=c4e19760&scoped=true"
import script from "./HeaderRubric.vue?vue&type=script&lang=js"
export * from "./HeaderRubric.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=c4e19760&prod&scoped=true&lang=css&external"
import style1 from "./HeaderRubric.vue?vue&type=style&index=1&id=c4e19760&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e19760",
  null
  
)

export default component.exports